export default [

  {
    title: "Dashboard",
    route: "user-dashboard",
    icon: "GridIcon",
    accountTypes: ["admin", "user"],
  },
  {
    title: "Dashboard",
    route: "partner-dashboard",
    icon: "HomeIcon",
    accountTypes: ["partner"],
  },
  {
    title: "All time analytics",
    route: "all-time-analytics",
    icon: "ClipboardIcon",
    accountTypes: ["partner", "admin"],
  },

  {
    header: "ACHIEVEMENTS",
    accountTypes: ["admin", "partner", "user"],
  },
  {
    title: "Accounts",
    icon: "UserIcon",
    route: "accounts",
    accountTypes: ["admin", "user"],
  },
  {
    title: "Categories",
    icon: "LayersIcon",
    route: "categories",
    accountTypes: ["admin"],
  },
  {
    title: "Partners",
    icon: "UsersIcon",
    route: "partners",
    accountTypes: ["admin"],
  },
  {
    title: "Users",
    icon: "UsersIcon",
    route: "users",
    accountTypes: ["admin"],
  },
  {
    title: "Sponsors",
    icon: "BriefcaseIcon",
    route: "sponsors",
    accountTypes: ["admin"],
  },
  {
    title: "Brokers",
    icon: "CheckSquareIcon",
    route: "brokers",
    accountTypes: ["admin"],
  },
  {
    title: "Competitions",
    icon: "AwardIcon",
    route: "competitions",
    accountTypes: ["admin", "partner", "user"],
  },
  {
    title: "Documents",
    icon: "FileTextIcon",
    route: "documents",
    accountTypes: ["admin", "partner", "user"],
  },
  {
    title: "Protests",
    icon: "FlagIcon",
    route: "protests",
    accountTypes: ["admin"],
  },
  {
    title: "Plans",
    icon: "FileTextIcon",
    route: "plans",
    accountTypes: ["admin" , "partner"],
  },
  {
    title: "Messages",
    icon: "MailIcon",
    route: "messages",
    accountTypes: ["admin"],
  },

  {
    header: "FINANCIAL",
    accountTypes: ["admin"],
  },
  {
    title: "Transacions",
    icon: "CheckSquareIcon",
    route: "financial-transactions",
    accountTypes: ["admin"],
  },
  {
    title: "Transfers",
    icon: "CheckSquareIcon",
    route: "financial-transfers",
    accountTypes: ["admin"],
  },
  {
    title: "Checkouts",
    icon: "CheckSquareIcon",
    route: "financial-checkouts",
    accountTypes: ["admin"],
  },
  {
    header: "MY WALLET",
    accountTypes: ["admin", "partner", "user"],
  },
  {
    title: "Overview",
    icon: "BriefcaseIcon",
    route: "wallet-overview",
    accountTypes: ["admin", "partner", "user"],
  },
  {
    title: "Deposit",
    icon: "ArrowDownCircleIcon",
    route: "wallet-deposit",
    accountTypes: ["admin", "partner", "user"],
  },
  {
    title: "Withdraw",
    icon: "ArrowUpCircleIcon",
    route: "wallet-withdraw",
    accountTypes: ["admin", "partner", "user"],
  },

  {
    title: "Transactions",
    icon: "CheckSquareIcon",
    route: "wallet-transactions",
    accountTypes: ["admin", "partner", "user"],
  },
  // {
  //   title: "Transfers",
  //   icon: "CheckSquareIcon",
  //   route: "wallet-transfers",
  // },
  // {
  //   header: "PERFORMANCE",
  // },
  // {
  //   title: "Trade History",
  //   icon: "BookOpenIcon",
  //   // route: "panel-trade-history",
  // },
  // {
  //   title: "Leader Board",
  //   icon: "ClipboardIcon",
  //   // route: "panel-leader-board",
  // },
  // {
  //   header: "AFFILIATE",
  // },
  // {
  //   title: "Affiliate Profile",
  //   icon: "ApertureIcon",
  //   // route: "panel-affiliate-profile",
  // },
  // {
  //   title: "Evaluation",
  //   icon: "EyeIcon",
  //   // route: "panel-evaluation",
  // },
  // {
  //   header: "EXTRAS",
  // },
  // {
  //   title: "Downloads",
  //   icon: "DownloadIcon",
  //   // route: "panel-downloads",
  // },
  // {
  //   title: "Analytics",
  //   icon: "PieChartIcon",
  //   // route: "panel-analytics",
  // },
];
